import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import mmh from "./about-img/mmh.png";
import founder from "./about-img/founder-msg.jpg";
import vision from "./about-img/our-vision.jpg";
import companies from "./about-img/companies.jpg";
import services from "./about-img/services.PNG";
import contact from "./about-img/contact.jpg";
import careers from "./about-img/careers.jpg";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/about-1750x984-overlay.jpg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>{rtl ? "تعرف علينا" : fr ? "À propos de nous" : `About Us`}</h1>
        </div>
      </div>
      {/* ********************** */}
      <div id="bodycont" class="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <Link to="/about">
                        {rtl
                          ? "مكة والمدينة القابضة المحدودة"
                          : fr
                          ? "Mecque & la Médine Holding LTD"
                          : `Makkah & Al Madinah Holding LTD`}
                      </Link>
                    </li>
                    <li>
                      <Link to="/founder">
                        {rtl
                          ? " رسالة المؤسس"
                          : fr
                          ? "Message du fondateur"
                          : `Founder's Message`}
                      </Link>
                    </li>
                    <li>
                      <Link to="/other">
                        {rtl
                          ? " موظفينا ورؤيتنا وقيمنا"
                          : fr
                          ? `Notre personnel, notre vision et nos
                          valeurs`
                          : `Our People, Our Vision, And
                                                Values`}
                      </Link>
                    </li>
                    <li>
                      <strong>
                        {rtl
                          ? "السيرة الذاتية لرئيس مجلس الإدارة"
                          : fr
                          ? "BIOGRAPHIE DU PRÉSIDENT"
                          : "Chairman Biography"}
                      </strong>
                      <p>
                        {rtl ? (
                          <a href="https://docdro.id/hndvwYr" target="_blank">
                            PDF عربي
                          </a>
                        ) : fr ? (
                          <a href="https://docdro.id/NBMNduH" target="_blank">
                            PDF Français
                          </a>
                        ) : (
                          <a href="https://docdro.id/CXEIOk4" target="_blank">
                            PDF English
                          </a>
                        )}
                      </p>
                    </li>
                  </ul>
                </div>

                <div class="sidelight white">
                  <h2>
                    {rtl
                      ? "وظائف مكة والمدينة القابضة المحدودة"
                      : fr
                      ? "CARRIÈRES MMH"
                      : "MMH Careers"}
                  </h2>
                  <img src={careers} class="crv2" />
                  <p>
                    {rtl
                      ? `تقدم وظائف مكة والمدينة القابضة المحدودة
 فرصا وظيفية مثيرة في جميع أنحاء العالم.
`
                      : fr
                      ? `MMH offre des opportunités de carrière
                      passionnantes à travers le monde`
                      : `MMH offers exciting career opportunities
                                        across the world.`}
                  </p>
                  <p>&nbsp;</p>
                  <Link to="/careers">
                    <p class="button2">
                      {rtl
                        ? "التعرف على المزيد"
                        : fr
                        ? "En savoir plus"
                        : "Learn More"}
                    </p>
                  </Link>
                </div>
              </div>
            </article>

            <article class="fluid three animated fadeInDown">
              <div class="col">
                <h1>
                  {rtl
                    ? "نبذة عن مكة  والمدينة القابضة المحدودة"
                    : fr
                    ? "A PROPOS DE MAKKAH & ALMADINA HOLDINGS LTD"
                    : "About MAKKAH & ALMADINA HOLDINGS LTD"}
                </h1>
                <p
                  style={{
                    background: "white",
                    padding: "0px 15px 15px",
                  }}
                >
                  {" "}
                  {rtl
                    ? "باعتبارها واحدة من أقدم قصص النجاح وأكثرها شهرة ، تم تشكيل  مكة  والمدينة القابضة من قبل سيدي شهيد ."
                    : fr
                    ? `MMH est l'une des plus anciennes et des plus célèbres
                    histoires de réussite au monde. Elle a été créée par Sidi
                    Shahid.`
                    : " As one of the world’s earliest and most celebrated success stories, MMH Was formed by Sidi Shahid ."}
                </p>
                <p>&nbsp;</p>
                <p
                  style={{
                    background: "white",
                    padding: "0px 15px 15px",
                  }}
                >
                  {rtl
                    ? `
تبحث مكة و المدينة القابضة المحدودة
 عن فرص حيث سيساعد الاستثمار في برامج التنمية الاقتصادية في إعادة بناء البلدان وخلق فرص العمل وتحسين نوعية الحياة للجميع. وفي هذا الصدد، تركز " مكة  والمدينة القابضة المحدودة
" حاليا على العديد من البلدان في أفريقيا بهدف توفير استثمارات معززة من شركائها الاستراتيجيين في الشرق الأوسط وأوروبا وجنوب آسيا.
 باستخدام هيكل التمويل الذاتي المبتكر لإطلاق التطوير ، لا يدخل المستثمرون الصورة إلا بعد الانتهاء من مراحل البحث والتصميم الأولية بنجاح
`
                    : fr
                    ? `MMH recherche des opportunités où l'investissement
                    dans des programmes de développement économique
                    aidera à reconstruire les pays, à créer des emplois et à
                    améliorer la qualité de vie de tous. À cet égard, MMH se
                    concentre actuellement sur plusieurs pays d'Afrique dans
                    le but de fournir des investissements accrus de la part de
                    ses partenaires stratégiques au Moyen-Orient, en Europe
                    et en Asie du Sud. Utilisant une structure
                    d'autofinancement innovante pour lancer le
                    développement, les investisseurs n'entrent en scène
                    qu'après que les phases initiales de recherche et de
                    conception aient été menées à bien.`
                    : `MMH seeks opportunities where investment in
                                    economic development programs will help
                                    rebuild countries, create jobs, and improve
                                    the quality of life for all. In this regard,
                                    MMH is currently focused on multiple
                                    countries in Africa with the objective of
                                    providing enhanced investments from its
                                    strategic partners in the Middle East,
                                    Europe and Southern Asia. Utilizing an
                                    innovative self-funding structure to launch
                                    development, investors enter the picture
                                    only after the initial research and design
                                    phases have been successfully completed.`}{" "}
                  {/* <Link to="/about">read more...</Link> */}
                </p>
                <p class="mt05">&nbsp;</p>

                <div className="aboutUs-cards">
                  <div
                    class="right-box-about ml-2"
                    style={{
                      width: "220px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl
                        ? ` مكة والمدينة القابضة المحدودة`
                        : fr
                        ? "Mecque & la Médine Holding LTD"
                        : "MMH LTD"}
                    </h1>
                    <a href="/about">
                      <img src={mmh} />
                    </a>
                    <p>
                      {rtl
                        ? `شكرا جزيلا على اهتمامكم بشركة مكة والمدينة القابضة المحدودة...`
                        : fr
                        ? `Merci beaucoup pour l'intérêt que vous
                        portez à Mecque & la Médine Holding
                        LTD...`
                        : `Thank you so much for your interest
                                            in Makkah & Al Madinah Holding
                                            LTD...`}
                      <br />
                      <Link to="/about-us">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>
                  <div
                    class="right-box-about"
                    style={{
                      width: "220px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl
                        ? "رسالة المؤسس"
                        : fr
                        ? "Message du fondateur"
                        : "Founder’s Message"}
                    </h1>
                    <Link to="/founder">
                      <img src={founder} />
                    </Link>
                    <p>
                      {rtl
                        ? `رسالة من مؤسسنا ورئيسنا التنفيذي السيد سيدي شهيد . . .`
                        : fr
                        ? `Un message de notre fondateur et PDG, M.
                        Sidi Shahid . . .`
                        : `A message from our founder and CEO,
                                            Mr. Sidi Shahid . . .`}
                      <br />
                      <Link to="/founder">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>
                  <div
                    class="right-box-about"
                    style={{
                      width: "240px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl
                        ? "رؤيتنا وقيمنا"
                        : fr
                        ? "NOTRE VISION ET NOS VALEURS"
                        : "Our vision and values"}
                    </h1>
                    <Link href="/other">
                      <img src={vision} />
                    </Link>
                    <p>
                      {rtl
                        ? "سيكون هدفنا هو تحسين نوعية الحياة"
                        : fr
                        ? `Notre objectif est d'améliorer la qualité de
                        la vie.`
                        : `Our objective will be to improve the
                                            quality of life `}
                      <br />
                      <Link to="/other">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>
                  <div class="clear"></div>

                  <div
                    class="right-box-about ml-2"
                    style={{
                      width: "220px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl
                        ? "شركاتنا"
                        : fr
                        ? "NOS ENTREPRISES"
                        : "Our Companies"}
                    </h1>
                    <Link to="/our-companies">
                      <img src={companies} />
                    </Link>
                    <p>
                      {rtl
                        ? `تتكون حافظة الاستثمارات سيدي شهيد من شركات متعددة...
`
                        : fr
                        ? `Le portfolio de Sidi Shahid est composé de
                        plusieurs entreprises. .`
                        : `The business portfolio of Sidi
                                            Shahid consists of multiple
                                            companies... `}
                      <br />
                      <Link to="/our-companies">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>

                  <div
                    class="right-box-about"
                    style={{
                      width: "220px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl ? "خدماتنا" : fr ? "NOS SERVICES" : `Our Services`}
                    </h1>
                    <Link to="/services">
                      <img src={services} />
                    </Link>
                    <p>
                      {rtl
                        ? `تلعب مكة والمدينة القابضة المحدودة دورا محوريا في تقدم العديد من البلدان.
`
                        : fr
                        ? `MMH joue un rôle central dans le progrès
                        de nombreux pays.`
                        : `MMH plays a pivotal role in many
                                            countries progress.`}{" "}
                      <br />
                      <Link to="/services">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>

                  <div
                    class="right-box-about"
                    style={{
                      width: "240px",
                      height: "300px",
                    }}
                  >
                    <h1>
                      {rtl ? "اتصل بنا" : fr ? "Nous Contacter" : "Contact Us"}
                    </h1>
                    <Link to="/contact-us">
                      <img src={contact} />
                    </Link>
                    <p>
                      {rtl
                        ? `للاتصال بنا عبر البريد الإلكتروني ، ما عليك سوى ملء النموذج أدناه.
`
                        : fr
                        ? `Pour nous contacter par email, il suffit de remplir le formulaire ci-dessous.
                        lire la suite...`
                        : `To contact us by email, simply fill
                                            in the form below.`}{" "}
                      <br />{" "}
                      <Link to="/contact-us">
                        {rtl
                          ? "اقرأ المزيد..."
                          : fr
                          ? "Lire la suite..."
                          : "Read More..."}
                      </Link>
                    </p>
                  </div>
                </div>
                <div class="clear"></div>

                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </article>
            {/* ****************************** */}

            {/* ******************************** */}
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
